<template>
  <v-card class="mx-auto mb-10">
    <v-img :src="menuImgUrl" height="200px"></v-img>
    <v-card-title>{{ menuTitle }}</v-card-title>
  </v-card>
</template>

<script>
export default {
  name: "ListMenuItem",
  props: ["menuImgUrl", "menuTitle"],
};
</script>

<style scoped>
.v-card {
  width: 340px;
}
@media (max-width: 600px) {
  .card-list {
    justify-content: center !important;
  }

  .v-card {
    width: 300px;
  }
}
</style>
